import { render, staticRenderFns } from "./PDPModalPaymentMethod.vue?vue&type=template&id=406eade8&scoped=true"
import script from "./PDPModalPaymentMethod.vue?vue&type=script&lang=js"
export * from "./PDPModalPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PDPModalPaymentMethod.vue?vue&type=style&index=0&id=406eade8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406eade8",
  null
  
)

export default component.exports